import React from 'react';
import SimpleSideMenuTemplate from '../templates/SimpleSideMenuTemplate';
const ErrorSidebar = props => {
  console.log('props', props);
  return /*#__PURE__*/React.createElement(SimpleSideMenuTemplate, {
    title: `Menù non disponibile`,
    description: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "error-title"
    }, "Qualcosa \xE8 andato storto. Si prega di ricaricare la pagina e riprovare. Se il problema persiste, contatta l'amministratore del sistema."), /*#__PURE__*/React.createElement("code", null, "Dettagli dell'errore: ", props.error.stack)),
    classes: {
      root: 'error-sidebar'
    }
  });
};
export default ErrorSidebar;